"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var CPPComment = function () {
    function CPPComment(body, blockType) {
        _classCallCheck(this, CPPComment);

        this.blockType = blockType;
        if (body instanceof Array) {
            this.body = body;
        } else {
            this.body = [body];
        }
    }

    _createClass(CPPComment, [{
        key: "appendBody",
        value: function appendBody(body) {
            if (body instanceof Array) {
                this.body = this.body.concat(body);
            } else {
                this.body.push(body);
            }
        }
    }, {
        key: "write",
        value: function write(formatter) {
            var indentCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var indent = formatter.indentation.repeat(indentCount);
            var output = '';
            if (this.blockType) {
                output += indent + "/*\n";
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.body[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var element = _step.value;

                    var _line = "" + indent;
                    if (this.blockType) {
                        _line += " * " + element;
                    } else {
                        _line += "// " + element;
                    }
                    output += _line.replace(/\s+$/, '') + "\n";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.blockType) {
                output += indent + " */";
            }
            return output.replace(/[\s|\n]*$/g, '');
        }
    }]);

    return CPPComment;
}();

exports.default = CPPComment;